module.exports = __webpack_public_path__ + "img/brands-harrys-bg-3.png?c2a47adb8eb6a13eaea65dd58607af2a";